import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 's1-card',
    templateUrl: './s1-card.component.html',
    styleUrls: ['./s1-card.component.scss'],
    standalone: false
})
export class S1Card implements OnInit {

  @Input() title: string;
  @Input() headerStyle: string = "bg-dark text-light";

  constructor() { }

  ngOnInit(): void {
  }

}
